import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReconstructedInterventionsGridComponent} from './reconstructed-interventions-grid.component';
import {TabModule} from '../tab/tab.module';
import {DxDataGridModule, DxDateBoxModule, DxSelectBoxModule, DxToolbarModule, DxPopupModule, DxButtonModule, DxFormModule, DxTextAreaModule, DxNumberBoxModule} from 'devextreme-angular';
import {ReconstructedInterventionsToolbarComponent} from './interventions-toolbar/interventions-toolbar.component';
import {ReconstructedInterventionReportModule} from './intervention-report/intervention-report.module';
import {GridTitleModule, BadgeModule} from 'shared';
import {DialogsModule} from './dialogs.module';


@NgModule({
  declarations: [
    ReconstructedInterventionsGridComponent,
    ReconstructedInterventionsToolbarComponent
  ],
  imports: [
    CommonModule,
    TabModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxSelectBoxModule,
    DxToolbarModule,
    DxPopupModule,
    DxButtonModule,
    DxFormModule,
    DxTextAreaModule,
    DxNumberBoxModule,
    ReconstructedInterventionReportModule,
    GridTitleModule,
    BadgeModule,
    DialogsModule,
  ],
  exports: [ReconstructedInterventionsGridComponent]
})
export class ReconstructedInterventionsGridModule {
}

